import { ImagePropertiesParams, RenderingProps } from 'src/shared/shared.types';
import { BiographyDirectoryFields } from '../C55BiographyDirectory/C55BiographyDirectory.types';

export type C56BiographyGridProps = RenderingProps<BiographyDirectoryFields, BiographyGridParams> &
  ImagePropertiesParams;

type BiographyGridParams = {
  GridNumberOfColumns?: string;
  HeadlineTag?: string;
};
